import { render, staticRenderFns } from "./updata-file.vue?vue&type=template&id=0807d7a6"
import script from "./updata-file.vue?vue&type=script&lang=ts"
export * from "./updata-file.vue?vue&type=script&lang=ts"
import style0 from "./updata-file.vue?vue&type=style&index=0&id=0807d7a6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports